import { render, staticRenderFns } from "./AxNavigationBreadcrumbs.vue?vue&type=template&id=24ab1960&scoped=true&"
import script from "./AxNavigationBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./AxNavigationBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./AxNavigationBreadcrumbs.vue?vue&type=style&index=0&id=24ab1960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab1960",
  null
  
)

export default component.exports